export default __webpack_public_path__ + "static/media/meeting-4-svgrepo-com.7a3a83f7.svg";